import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import Translations from "@/components/utils/Translations";

Vue.use(VueI18n);

const messages: LocaleMessages = {
    sk: {},
    en: {},
};

const locales = require.context(
    './',
    true,
    /[A-Za-z0-9-_,\s]+\.ts$/i,
);

locales.keys().forEach((key) => {
    if (key.includes('i18n.ts')) return;
    const locale = key.slice(2, 4);
    const prop = key.slice(5, -3);
    messages[locale][prop] = locales(key).default;
});

const i18n = Translations(messages);
export default i18n;
